import { Link } from "react-router-dom";
import classNames from "classnames";

interface GradientLinkProps {
  to?: string; // Make 'to' optional
  classes?: string; // Make className optional
  children: React.ReactNode;
  onClick?: Function; // Optional onClick handler
  selected?: boolean;
}

const GradientLink = ({
  to,
  classes,
  children,
  onClick,
  selected,
  ...props
}: GradientLinkProps) => {
  const handleMouseMove = (e) => {
    const linkElement = e.currentTarget;
    const rect = linkElement.getBoundingClientRect();

    // Get the cursor position relative to the link element
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Set the gradient's position to the cursor position
    linkElement.style.setProperty("--gradient-x", `${x}px`);
    linkElement.style.setProperty("--gradient-y", `${y}px`);
  };

  return (
    <>
      {to ? (
        <Link
          to={to}
          className={classNames(
            "gradiant-link",
            classes,
            selected && "gradiant-link-selected"
          )}
          onMouseMove={handleMouseMove}
          {...props}
        >
          <span className="relative z-10">{children}</span>
        </Link>
      ) : onClick ? (
        <button
          onClick={() => onClick && onClick()}
          className={classNames(
            "gradiant-link",
            classes,
            "cursor-pointer",
            "text-left"
          )}
          onMouseMove={handleMouseMove}
          {...props}
        >
          <span className="relative z-10">{children}</span>
        </button>
      ) : (
        <></>
      )}
    </>
  );
};

export default GradientLink;
